import { render, staticRenderFns } from "./Mantainance.vue?vue&type=template&id=63012adc&"
import script from "./Mantainance.vue?vue&type=script&lang=ts&"
export * from "./Mantainance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports